import Check from '@mui/icons-material/Check';
import DoNotDisturbAlt from '@mui/icons-material/DoNotDisturbAlt';
import Title from '@mui/icons-material/Title';
import { styled } from '@mui/material/styles';

const iconSx = { width: 20, height: 20 };

export const CheckIconStyled = styled(Check)(({ theme }) => ({
  color: theme.palette.success.light,
  ...iconSx,
}));

export const DoNotDisturbAltIconStyled = styled(DoNotDisturbAlt)(({ theme }) => ({
  color: theme.palette.error.light,
  ...iconSx,
}));

export const TitleIconStyled = styled(Title)(({ theme }) => ({
  color: theme.palette.warning.light,
  ...iconSx,
}));
